import { Badge } from "@app/components/ui/badge";

const STATUS_CONFIG: Record<
  string,
  {
    label: string;
    variant: "default" | "secondary" | "destructive" | "outline";
  }
> = {
  PENDING: { label: "En attente", variant: "secondary" },
  RUNNING: { label: "En cours...", variant: "default" },
  COMPLETED: { label: "Terminé", variant: "default" },
  FAILED: { label: "Échoué", variant: "destructive" },
  CANCELLED: { label: "Annulé", variant: "outline" },
};

interface ExperimentStatusBadgeProps {
  status: string;
}

export function ExperimentStatusBadge({ status }: ExperimentStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || {
    label: status,
    variant: "secondary" as const,
  };

  return <Badge variant={config.variant}>{config.label}</Badge>;
}
